import {CONVERTER_ALLOWED_IMAGE_TYPES, CONVERTER_MAX_IMAGE_SIZE_BYTES} from '../../../common/constants/assetUpload'
import {loadImageAsDataUrl} from '../../../common/utils/spriteUpload'

export type ConverterImageLoadErrorKey = 'invalidType' | 'tooLarge' | 'failed'

export class ConverterImageLoadError extends Error {
  readonly key: ConverterImageLoadErrorKey
  constructor(key: ConverterImageLoadErrorKey) {
    super(key)
    this.key = key
  }
}

const loadImageFromUrl = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new ConverterImageLoadError('failed'))
    img.src = url
  })

/**
 * Animated GIF input decodes via the browser's own <img> rasterization, which
 * only renders the first frame — this is a browser-decoder limitation, not
 * something handled here. Callers should surface a UI hint, not an error.
 */
export const loadConverterImageFile = async (file: File): Promise<HTMLImageElement> => {
  if (!CONVERTER_ALLOWED_IMAGE_TYPES.has(file.type)) throw new ConverterImageLoadError('invalidType')
  if (file.size > CONVERTER_MAX_IMAGE_SIZE_BYTES) throw new ConverterImageLoadError('tooLarge')
  const dataUrl = await loadImageAsDataUrl(file)
  return loadImageFromUrl(dataUrl)
}
